import Vue from 'vue'
import VueRouter from 'vue-router'
import LayoutMobile from '../views/mobile/layout/Navigation.vue'
import PersonalNav from '../views/mobile/layout/PersonalNav.vue'
import Home from '../views/mobile/Home.vue'

Vue.use(VueRouter)

const mobiles = [

  {
    path: '/usercenter',
    component: PersonalNav,
    children: [
      {
        path: '',
        name: 'MUsercenter',
        redirect: 'userinfo',
        meta: { title: '用户中心' },
      },
      {
        path: '/userinfo',
        name: 'MUserInfo',
        component: () => import('../views/mobile/UserInfo.vue'),
        meta: { title: '用户中心' },
      },
      {
        path: '/myachievement',
        name: 'MMyAchievement',
        component: () => import('../views/mobile/MyAchievement.vue'),
        meta: { title: '我的成绩' },
      },
      {
        path: '/mycertificate',
        name: 'MMyCertificate',
        component: () => import('../views/mobile/MyCertificate.vue'),
        meta: { title: '用户中心' },
      },
    ],
  },
  {
    path: '/',
    component: LayoutMobile,
    children: [
      {
        path: '/home',
        name: 'MHome',
        component: Home,
        meta: { title: '官网' },
      },
      {
        path: '/guide',
        name: 'MGuide',
        component: () => import('../views/mobile/Guide.vue'),
        meta: { title: '报考指南' },
      },
      {
        path: '/examination',
        name: 'MExamination',
        component: () => import('../views/mobile/Examination.vue'),
        meta: { title: '参加考试' },
      },
      {
        path: '/catalog',
        name: 'MCatalog',
        component: () => import('../views/mobile/catalog.vue'),
        meta: { title: '课程目录' },
      },
      {
        path: '/certificate',
        name: 'MCertificate',
        component: () => import('../views/mobile/Certificate.vue'),
        meta: { title: '证书发放' },
      },
      {
        path: '/traincourse',
        name: 'MTraincourse',
        component: () => import('../views/mobile/Traincourse.vue'),
        meta: { title: '培训课程' },
      },
      {
        path: '/login',
        name: 'MLogin',
        component: () => import('../views/mobile/Login.vue'),
        meta: { title: '登录' },
      },
      {
        path: '/register/:agent?',
        name: 'MRegister',
        component: () => import('../views/mobile/Register.vue'),
        meta: { title: '注册' },
      },
      {
        path: '/reset',
        name: 'MReset',
        component: () => import('../views/mobile/Reset.vue'),
        meta: { title: '重置密码' },
      },
      {
        path: "/team",
        name: "Mteam",
        component: () => import("../views/mobile/team.vue"),
        meta: { title: "课程师资" },
      },

      {
        path: '/agreement',
        name: 'MAgreement',
        component: () => import('../views/mobile/Agreement.vue'),
        meta: { title: '平台协议' },
      },

      {
        path: '/course/:id?',
        name: 'Course',

        component: () => import('../views/mobile/course.vue'),
        meta: { title: '生涯规划咨询师' },
      },
      {
        path: '/videoplays/:cid/:uid/:id',
        name: 'Videoplays',

        component: () => import('../views/mobile/videoplays.vue'),
        meta: { title: '视频播放' },
      },
      {
        path: '/exam_wp/:id',
        name: 'exam_wp',
        meta: { title: '考试页', icon: 'dashboard', auth: 'user' },
        component: () => import('../views/mobile/exam_wp.vue'),
      },

      {
        path: '/examVerify',
        name: 'examVerify',
        component: () => import('../views/mobile/examVerify.vue'),
      },

      {
        path: '/:agent?',
        name: 'MIndex',
        component: Home,
        meta: { title: '官网' },
      },

    ],
  },
]

export default mobiles
